var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseFilledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-filled",
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40376",
    "data-name": "Group 40376",
    transform: "translate(4.5 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59960",
    "data-name": "Path 59960",
    d: "M11.5,4.5a7,7,0,1,0,7,7A6.957,6.957,0,0,0,11.5,4.5ZM14.2,15l-2.7-2.7L8.8,15,8,14.2l2.7-2.7L8,8.8,8.8,8l2.7,2.7L14.2,8l.8.8-2.7,2.7L15,14.2Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#dc1e1e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilledIcon);
export default __webpack_public_path__ + "static/media/close_filled_icon.34ce262b45daaca5f16ae05b7e6aa76c.svg";
export { ForwardRef as ReactComponent };